'use client'

import { Button, Navigation, Text } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import { useLocation } from '@marketplace-web/shared/browser'
import { useTracking } from '@marketplace-web/shared/event-tracker'

import { ClickableElement } from 'constants/tracking/clickable-elements'
import { clickEvent } from '_libs/common/event-tracker/events'

export type Props = {
  discountHint?: string
  pathBack: string
}

const BundleHeader = ({ discountHint, pathBack }: Props) => {
  const { track } = useTracking()
  const { safeBack } = useLocation()

  const trackCloseAction = () => {
    track(
      clickEvent({
        target: ClickableElement.CancelBundle,
      }),
    )
    safeBack(pathBack)
  }

  const renderHeaderLeft = () => (
    <Button
      iconName={X24}
      styling={Button.Styling.Flat}
      inline
      onClick={trackCloseAction}
      testId="bundle-header-close-button"
    />
  )

  const renderHeaderBody = () => {
    return (
      <Text
        as="h3"
        type={Text.Type.Subtitle}
        format
        text={discountHint}
        theme="success"
        width={Text.Width.Parent}
        alignment={Text.Alignment.Center}
        testId="bundle-header-title"
      />
    )
  }

  return <Navigation left={renderHeaderLeft()} body={renderHeaderBody()} />
}

export default BundleHeader
